import { ReportDashboardComponent, ReportDashboardMetricOptions } from '@core/reports-types';

/**
 * Tells whether the visualization dataset ends up with a second dimension.
 *
 * A metric with a `defaultGroup` gets it injected as the primary group at
 * visualization time (see `applyDefaultGroupping`), which pushes the selected
 * group into the second dimension even though the form keeps it as the primary
 * one.
 */
export const hasSecondDimension = (
  groups: Partial<Pick<ReportDashboardComponent, 'primaryGroup' | 'secondaryGroup'>>,
  metric: ReportDashboardMetricOptions,
): boolean => {
  if (groups.secondaryGroup) {
    return true;
  }

  const primaryGroup = groups.primaryGroup ?? '';
  return !!metric.defaultGroup && primaryGroup !== '' && primaryGroup !== metric.defaultGroup;
};
